import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

// Visionneuse plein écran : un appui sur une image l'affiche en grand, un appui
// (ou le bouton) la referme. Simple SURCOUCHE — la page en dessous (Kids,
// séance en cours…) n'est ni rechargée ni réinitialisée.
export default function Lightbox({ src, alt = "", onClose, testId = "lightbox" }) {
  return (
    <AnimatePresence>
      {src && (
        <motion.div
          className="rav-lightbox"
          data-testid={testId}
          role="dialog"
          aria-label="Image en plein écran"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          onClick={onClose}
        >
          <button type="button" className="rav-lightbox-close" data-testid={`${testId}-close`} aria-label="Refermer l'image" onClick={onClose}>
            <X size={20} strokeWidth={1.8} />
          </button>
          <motion.img
            src={src}
            alt={alt}
            className="rav-lightbox-img"
            data-testid={`${testId}-img`}
            initial={{ scale: 0.92, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
